import { store } from '@/store/main';
import { loadStylepacks } from '@/store/slices/stylepacks';

export const stylepacksLoader = async (): Promise<Response> => {
  try {
    store.dispatch(loadStylepacks());
    return new Response(null, { status: 200 });
  } catch (e) {
    console.error(e);
    return new Response(null, { status: 500 });
  }
};
